import tf from './textarea-format.vue';
export default tf;



// WEBPACK FOOTER //
// ./src/components/textarea-format/index.js